import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { useAuthStore } from '@/stores/auth.store'

export const Route = createFileRoute('/_authenticated')({
  /**
   * Garde d'authentification en `beforeLoad`, pas en `useEffect`.
   *
   * L'effet s'exécutait APRÈS le rendu : la page protégée s'affichait une
   * fraction de seconde, et surtout l'effet repassait (deux fois en dev sous
   * StrictMode) avec une location déjà changée — la seconde navigation écrasait
   * le `?redirect=` que la première venait de poser. `beforeLoad` tranche avant
   * tout rendu, une seule fois, et la destination survit.
   *
   * `getState()` plutôt qu'un hook : on est hors composant. Le store est
   * persisté sur `localStorage`, lu de façon synchrone — l'état est donc déjà
   * hydraté ici, un client connecté n'est pas renvoyé vers la connexion.
   */
  beforeLoad: ({ location }) => {
    const { isAuthenticated, user } = useAuthStore.getState()

    if (!isAuthenticated || !user) {
      // La destination voyage avec la redirection : un client qui clique le CTA
      // d'un mail sans être connecté doit retrouver SON dossier après s'être
      // identifié, pas la page d'accueil.
      throw redirect({ search: { redirect: location.href }, to: '/connexion' })
    }
  },
  component: Outlet,
})
